<template>
  <div>
    <div
      class=""
      style="background: linear-gradient(0deg, #908e47 0%, #b1ae58 100%)"
    >
      <div class="padding-70-30 flex-row flex-center justify-between">
        <div class="flex-row flex-center">
          <img
            class="icon-7x"
            :src="uploadpath + 'resource/' + Res.tx_logo"
            alt=""
          />
          <div class="margin-left width-4x">
            <div class="flex-row flex-center">
              <div class="color-w">
                {{ Member != null && Member != "" ? Member.mobile : "" }}
              </div>
              <img
                class="icon-13x margin-left-1x"
                :src="uploadpath + 'resource/' + Res.zhushi1"
                alt=""
                @click="isexplain"
              />
              <el-dialog :visible.sync="my_explain" width="70%" :show-close="false">
                <span>{{ Inst.my_explain }}</span>
              </el-dialog>
            </div>
            <!-- <div class="color-w" v-if="Member.phone==null">登录|注册</div> -->
            <div class="flex-row flex-center justify-between">
              <div
                class="
                  color-w
                  border-xrf
                  f-24
                  text-center
                  margin-top
                  padding-8-10
                "
                style="
                  background: linear-gradient(-57deg, #252405 0%, #3a380f 100%);
                "
              >
                实力：{{ Member != null && Member != "" ? Member.credit : "" }}
              </div>
              <div
                class="
                  color-w
                  border-xrf
                  f-24
                  text-center
                  margin-top
                  padding-8-10
                "
                style="
                  background: linear-gradient(-57deg, #252405 0%, #3a380f 100%);
                "
              >
                积分：{{ Member != null && Member != "" ? Member.jifen : "" }}
              </div>
            </div>
          </div>
        </div>
        <img
          class="icon-12x"
          :src="uploadpath + 'resource/' + Res.quit"
          alt=""
          @click="isdialog"
        />
        <el-dialog title="提示" :visible.sync="dailogVisible" width="70%">
          <span>是否退出登录</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dailogVisible = false">取消</el-button>
            <el-button type="primary" @click="quit">确定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
    <div
      class="bg-g4 padding-top-4x padding-left-3x padding-bottom f-32 bold-5"
    >
      点评记录
    </div>
    <div
      class="
        bg-g4
        flex-row flex-center
        justify-between
        padding-bottom padding-left-3x
      "
    >
      <!-- <div
        class="bg-g16 color-w xiala text-center margin-left-3x h2"
        @click="recordList(member_id, '', '')"
      >
        全部
      </div> -->
      <el-select v-model="typeValue" placeholder="全部" @change="request_type">
        <el-option
          v-for="item in typeList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <div class="flex-row flex-center justify-between" style="h-80">
        <div
          class="f-g4 bg-w padding-10-30 margin-right-3x h-55 padding-top"
          @click="showPopup2"
        >
          {{ value2 }}
        </div>
      </div>
    </div>
    <van-popup v-model="show2" position="bottom" :style="{ height: '40%' }">
      <van-datetime-picker
        @confirm="confirm2"
        @cancel="cancel2"
        v-model="currentDate2"
        type="year-month"
        title="选择时间"
        :min-date="minDate2"
        :max-date="maxDate2"
      >
      </van-datetime-picker>
    </van-popup>
    <div class="bg-g4 padding-left-3x padding-right-3x scrollY h60">
      <div
        class="bg-w border-5x padding-30-20 margin-top"
        v-for="(item, i) in record"
        v-bind:key="i"
      >
        <div class="f-24">{{ item.created_date }}</div>
        <div class="flex-row flex-center justify-between">
          <div>
            <div class="h2 margin-top">
              {{ item.r_tb_shop1_name
              }}<img
                class="icon1 margin-left-1x"
                :src="uploadpath + 'resource/' + Res.dianzan"
                alt=""
                v-if="item.num1 == 1"
              />
            </div>

            <div class="margin-top h2">
              {{ item.r_tb_shop2_name
              }}<img
                class="icon1 margin-left-1x"
                :src="uploadpath + 'resource/' + Res.dianzan"
                alt=""
                v-if="item.num2 == 1"
              />
            </div>
          </div>
          <div>
            <img
              class="icon-7x"
              :src="uploadpath + 'resource/' + Res.vs"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="bg-g4 padding-top padding-bottom">
      <div
        class="
          text-center
          f-20 f-g3
          margin-top-3x
          flex-row flex-center
          justify-center
        "
      >
        <div class="f-s1 f-24" @click="routeto('about')">关于我们</div>
        <div class="margin-left margin-right f-s1 f-24">|</div>
        <div class="f-s1 f-24" @click="routeto('suggest')">意见反馈</div>
      </div>
      <div class="text-center f-20 f-g3 margin-bottom-3x margin-top-1x">
        {{ Inst.copyright }}
      </div>
      <div
        class="text-center f-20 margin-bottom margin-top-1x f-p2"
        style="text-decoration: underline"
        @click="gongxin()"
      >
        {{ Inst.filing }}
      </div>
    </div>
    <img
      class="icon-11x under2"
      :src="uploadpath + 'resource/' + Res.back"
      alt=""
      @click="routeto('/')"
    />
  </div>
</template>
<script>
import Config from "../Config";
import { PageHelper } from "../PageHelper";
import { HttpHelper } from "../HttpHelper";
import { Utils } from "../Utils";

export default {
  inject: ["reload"], //原来导入App.vue中的刷新方法
  data() {
    return {
      typeValue: "",
      type_id: "",
      typeList: [],
      Res: {},
      Inst: {},
      Member: [],
      bannerlist: [],
      productlist: [],
      problemlist: [],
      attrlist: [],
      list: [],
      show: false,
      right: "A",
      dailogVisible: false,
      record: [],
      mobile: "",
      value2: "请选择日期", //结束时间显示
      show2: false, //弹出框是否显示
      minDate2: new Date(2000, 0, 1), //结束时间
      maxDate2: new Date(), //结束时间
      currentDate2: new Date(), //结束时间
      loginshow: false,
      member_id: "",
      list: [],
      my_explain: false,
      // num1:'',
      // num2:''
    };
  },
  created() {
    // this.reload();
    PageHelper.Init(this);
    // let _this = this;
    // console.log(let_this)
    // console.log(_this.Member)
    HttpHelper.Post("shop/type", {}).then((ret) => {
      let list1 = { id: 0, name: "请选择" };
      this.list[0] = list1;
      for (let i = 0; i < ret[0].count; i++) {
        this.list[i + 1] = ret[i];
      }
      console.log(this.list);
      this.typeList = this.list;
    });
    this.mobile = window.localStorage.getItem("mobile");
    HttpHelper.Post("Member/info", { phone: this.mobile }).then((ret) => {
      this.Member = ret;
      this.member_id = ret.id;
      console.log(ret);
      this.recordList(ret.id, "", "");
    });
    console.log(this.value2);
  },
  methods: {
    request_type(val) {
      console.log("abc", val);
      this.type_id = val;
      if (this.value2 != "请选择日期") {
        //获取到的时间
        let times =
          this.currentDate2.getFullYear() +
          "-" +
          (this.currentDate2.getMonth() + 1).toString().padStart(2, "0");
        this.recordList(this.member_id, times, val);
      } else {
        this.recordList(this.member_id, "", val);
      }
    },
    //结束时间确定
    confirm2() {
      this.show2 = false; //弹出框隐藏
      //拼接显示时间 年月日时分秒,toString().padStart(2, "0")这个是将1:1:0显示为01:01:00
      this.value2 =
        this.currentDate2.getFullYear() +
        "年" +
        (this.currentDate2.getMonth() + 1).toString().padStart(2, "0") +
        "月";
      this.value1 =
        this.currentDate2.getFullYear() +
        "-" +
        (this.currentDate2.getMonth() + 1).toString().padStart(2, "0");
      // this.Cxorder(this.value1);

      //获取到的时间
      let times =
        this.currentDate2.getFullYear() +
        "-" +
        (this.currentDate2.getMonth() + 1).toString().padStart(2, "0");
      console.log(this.currentDate2);
      if (this.type_id != "" && this.type_id != 0) {
        this.recordList(this.member_id, times, this.type_id);
      } else {
        this.recordList(this.member_id, times, "");
      }
    },
    //结束时间取消
    cancel2() {
      this.show2 = false; //弹出框隐藏
      this.value2 = "请选择日期";
      this.currentDate2 = new Date();
      if (this.type_id != "" && this.type_id != 0) {
        this.recordList(this.member_id, "", this.type_id);
      } else {
        this.recordList(this.member_id, "", "");
      }
    },
    //结束时间弹出层
    showPopup2() {
      this.show2 = true; //弹出框显示
    },
    quit() {
      window.localStorage.setItem("token", null);
      window.localStorage.setItem("mobile", "");
      this.dailogVisible = false;
      this.routeto("login");
    },
    recordList(id, time, type) {
      HttpHelper.Post("shop/record", {
        id: id,
        time: time,
        type_id: type,
      }).then((res) => {
        this.record = res;
      });
    },
    isdialog() {
      this.dailogVisible = true;
    },
    isexplain() {
      this.my_explain = true;
    },
    gongxin() {
      window.location.href = this.Inst.url;
    },
  },
};
</script>
<style scoped>
.el-dialog__wrapper {
  position: fixed;
  top: 25%;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
}
.padding-70-30 {
  padding: 70px 30px;
}
.padding-30-20 {
  padding: 30px 20px;
}
.padding-10-30 {
  padding: 10px 30px;
}
.padding-8-10 {
  padding: 8px 10px;
}
.border-xrf {
  border-radius: 0px 20px 20px 20px;
}

.icon1 {
  width: 36px;
  height: 36px;
}
.scrollY {
  overflow-y: scroll;
}
.h60 {
  height: 59.2%;
}
.xiala {
  width: 140px;
  height: 48px;
  border-radius: 24px;
  line-height: 48px;
}
.border-24x {
  border-radius: 24px;
}
.el-select {
  width: 200px;
  height: 80px;
}
.h-55 {
  height: 55px;
}
</style>


// WEBPACK FOOTER //
// src/components/My.vue